// extracted by mini-css-extract-plugin
export default {"message":"partner-discount-invalid-message_message__82e2a"};